import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStore } from '@app/stores';

/**
 * Guard que verifica la autenticación antes de activar una ruta protegida.
 * Delega en authStore.ping() que internamente:
 *  - Verifica la sesión con el backend
 *  - Carga el usuario si no está cargado
 *  - Redirige a /login si no hay sesión válida
 */
export const authGuard: CanActivateFn = () => {
  return inject(AuthStore).ping();
};
